(() => {
  const setup = (root) => {
    const mainEl = root.querySelector("[data-gallery-main]");
    if (!mainEl || mainEl.dataset.galleryReady === "true") return;
    if (mainEl.querySelectorAll(".swiper-slide").length < 2) return;
    mainEl.dataset.galleryReady = "true";

    const thumbsEl = root.querySelector("[data-gallery-thumbs]");
    let thumbs = null;

    if (thumbsEl) {
      thumbs = new Swiper(thumbsEl, {
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
      });
    }

    const main = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: { enabled: true },
      a11y: { enabled: true },
      // Off-screen slides are loading="lazy", so pull in the neighbours to
      // avoid swiping onto a blank slide.
      lazyPreloadPrevNext: 1,
      // Recover if the gallery is measured before it has its final width
      // (webfonts, images and app-injected layout can all shift it).
      observer: true,
      observeParents: true,
      resizeObserver: true,
      thumbs: thumbs ? { swiper: thumbs } : undefined,
    });

    main.on("slideChange", () => {
      mainEl.querySelectorAll("video").forEach((video) => video.pause());

      // Keep the active thumbnail in view: with freeMode + auto widths the
      // thumbs module doesn't reliably scroll the strip itself.
      if (thumbs) {
        const thumb = thumbs.slides[main.activeIndex];
        if (!thumb) return;

        const stripWidth = thumbsEl.clientWidth;
        const left = thumb.offsetLeft;
        const right = left + thumb.offsetWidth;
        const scrolled = -thumbs.translate;

        if (left < scrolled || right > scrolled + stripWidth) {
          thumbs.slideTo(main.activeIndex);
        }
      }
    });
  };

  // Swiper can arrive late: speed-optimiser apps routinely rewrite defer to
  // async, which drops the guaranteed execution order between the two tags.
  // Waiting beats bailing out silently. If it never turns up, the CSS
  // scroll-snap fallback keeps the gallery swipeable.
  const whenSwiperReady = (callback) => {
    if (window.Swiper) {
      callback();
      return;
    }

    let waited = 0;
    const timer = setInterval(() => {
      if (window.Swiper) {
        clearInterval(timer);
        callback();
      } else if ((waited += 100) >= 10000) {
        clearInterval(timer);
      }
    }, 100);
  };

  const boot = (root) => whenSwiperReady(() => setup(root));

  boot(document);
  document.addEventListener("shopify:section:load", (event) => boot(event.target));
})();
